/* eslint-disable react/prop-types */
import { RouteComponentProps } from "@reach/router"
import { usePolicyAndFleet } from "../contexts"
import { IFrame } from "./iframe"

export const ClaimSubmissions: React.FC<RouteComponentProps & { submissionReference?: string }> = (props) => {
  const { policy } = usePolicyAndFleet()
  const { submissionReference } = props

  return <IFrame path={`policies/${policy.id}/claim-submissions/${submissionReference}/review`} />
}
